import TankMenu from "../TankMenu/TankMenu";


const SubHeaderTank = ({ tanks, showDetails = false, canHostBatch = false }) => {

  let batchTanks = {}, technicalTanks = {};
  tanks.forEach((tank) => {
    const idTankType = tank.tank_type.id;
    let acc;
    if(tank.tank_type.canHostBatch)
      acc = batchTanks
    else
      acc = technicalTanks

    if (!acc[idTankType])
      acc[idTankType] = [];

    acc[idTankType].push(tank);

    return acc;
  });


  return (
    <div className={`flex w-full items-center justify-around px-4 pb-2 backdrop-blur-xl shadow-md relative z-20 dark:bg-black/20 bg-slate-300/40`}>
      <TankMenu tanks={tanks} batchTanks={Object.values(batchTanks)} technicalTanks={Object.values(technicalTanks)}/>
    </div>
  )
}

export default SubHeaderTank
